import { render, staticRenderFns } from "./AccountAddOn.vue?vue&type=template&id=713cc8e4&"
import script from "./AccountAddOn.vue?vue&type=script&lang=js&"
export * from "./AccountAddOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports